<div class="column">
  <app-option-button
    buttonText="Upload New Project"
    route="/new-project-upload"
  ></app-option-button>
  <app-option-button
    buttonText="Upload Existing project"
    route="/existing-project-upload"
  ></app-option-button>
</div>
